import PropTypes from 'prop-types'
import FullScreenLocationMap from './FullScreenLocationMap'

const Content = ({ listing }) => <FullScreenLocationMap listing={listing} />

Content.propTypes = {
  listing: PropTypes.object,
}

export default Content
